export const replaceWithRound = (grade: string) =>
  grade.replace(/\d+(\.\d+)?/g, match => Math.round(Number(match)).toString());
